import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=cc3329da&"
import script from "./empty.vue.ts?vue&type=script&lang=ts&"
export * from "./empty.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports